import Add from './Add';
import AiAssistant from './AiAssistant';
import Archived from './Archived';
import Bell from './Bell';
import Booked from './Booked';
import Calendar from './Calendar';
import Cancel from './Cancel';
import Chart from './Chart';
import Check from './Check';
import Clear from './Clear';
import Clock from './Clock';
import Company from './Company';
import Dashboard from './Dashboard';
import Database from './Database';
import Display from './Display';
import Document from './Document';
import Dollar from './Dollar';
import Draft from './Draft';
import Edit from './Edit';
import FastTranslate from './FastTranslate';
import Gear from './Gear';
import Headphones from './Headphones';
import Hint from './Hint';
import HorizontalLayout from './HorizontalLayout';
import Image from './Image';
import Info from './Info';
import InProgress from './InProgress';
import Megaphone from './Megaphone';
import MouseCursor from './MouseCursor';
import Newspaper from './Newspaper';
import Offered from './Offered';
import Pause from './Pause';
import Payout from './Payout';
import Percentage from './Percentage';
import Person from './Person';
import PersonAdd from './PersonAdd';
import PersonRemove from './PersonRemove';
import Phone from './Phone';
import Photo from './Photo';
import Play from './Play';
import PlayAlt from './PlayAlt';
import Preview from './Preview';
import PreviewCrossed from './PreviewCrossed';
import Rectangle from './Rectangle';
import Remove from './Remove';
import Revenue from './Revenue';
import Rise from './Rise';
import SettingsAlt from './SettingsAlt';
import Square from './Square';
import Tag from './Tag';
import Targeting from './Targeting';
import TemporaryUnavailable from './TemporaryUnavailable';
import Users from './Users';
import Warning from './Warning';
export const FilledIcons = {
    Add,
    AiAssistant,
    Archived,
    Bell,
    Booked,
    Calendar,
    Cancel,
    Chart,
    Check,
    Clear,
    Clock,
    Company,
    Dashboard,
    Database,
    Display,
    Document,
    Dollar,
    Draft,
    Edit,
    FastTranslate,
    Gear,
    Headphones,
    Hint,
    HorizontalLayout,
    Info,
    Image,
    InProgress,
    Megaphone,
    MouseCursor,
    Newspaper,
    Offered,
    Pause,
    Payout,
    Percentage,
    Person,
    PersonAdd,
    PersonRemove,
    Phone,
    Photo,
    Play,
    PlayAlt,
    Preview,
    PreviewCrossed,
    Rectangle,
    Remove,
    Revenue,
    Rise,
    SettingsAlt,
    Square,
    Tag,
    Targeting,
    TemporaryUnavailable,
    Users,
    Warning,
};
export default FilledIcons;
